<template>
<div class="card mb-5 mb-xl-10">
    <div class="card-body pt-9 pb-0" v-if="user.id">
        <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
            <div class="me-7 mb-4">
                <div class="symbol symbol-30px symbol-md-40px symbol-fixed position-relative">
                    <img v-bind:src="user.image_url" alt="image">
                </div>
            </div>

            <div class="flex-grow-1">
                <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mb-2">
                            <router-link :to="{name:'my.Account' }" class="text-gray-900 text-hover-primary fs-2 fw-bold me-1">{{user.full_name}}</router-link>
                        </div>

                        <div class="d-flex flex-wrap fw-semibold fs-4 mb-4 pe-2">

                        </div>
                    </div>
                </div>


            </div>
        </div>

        <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
            <li class="nav-item mt-2">
                <router-link :to="{name: 'my.Account'}" class="nav-link text-active-primary ms-0 me-10 py-5" :class="$route.name==='my.Account' ? 'active' : ''">{{$t('profile_details')}}</router-link>
            </li>
            <li class="nav-item mt-2">
                <router-link :to="{name: 'my.Taxpays'}" class="nav-link text-active-primary ms-0 me-10 py-5" :class="$route.name==='my.Taxpays' ? 'active' : ''">{{$t('my_taxpays')}}</router-link>
            </li>
            <li class="nav-item mt-2">
                <router-link :to="{name: 'my.Payments'}" class="nav-link text-active-primary ms-0 me-10 py-5" :class="$route.name==='my.Payments' ? 'active' : ''">{{$t('history_payments')}}</router-link>
            </li>
            <li class="nav-item mt-2">
                <router-link :to="{name: 'my.Certificates'}" class="nav-link text-active-primary ms-0 me-10 py-5" :class="$route.name==='my.Certificates' ? 'active' : ''">{{$t('Adeverinte')}}</router-link>
            </li>
        </ul>
    </div>
</div>
</template>
<script>


export default {
    name: 'MyTopheader',
    props: ['activmenu'],
    computed : {
        isLoggedIn : function(){ return this.$store.getters['auth/isAuthenticated'] },
        user : function(){ return this.$store.getters['auth/getFullUser'] },
    },
    methods: {


    }
}
</script>
